/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import {
  DefaultRoutePageMetaResolver,
  TranslationService,
} from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { CurrentBudgetService } from './current-budget.service';
import {Budget} from "../../../core/model";

@Injectable({ providedIn: 'root' })
export class BudgetRoutePageMetaResolver extends DefaultRoutePageMetaResolver {
  constructor(
    translation: TranslationService,
    protected currentItemService: CurrentBudgetService
  ) {
    super(translation);
  }

  protected getParams(): Observable<Budget | undefined> {
    return this.currentItemService.item$;
  }
}
